import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSeoTranslations, fallbackTranslations } from './seoTranslations';
import generatedTranslations from './generatedTranslations.json';

export const languageKeys = [
  'en', 'ru', 'pt', 'ar', 'bn', 'da', 'de', 'el', 'es', 'fi', 
  'fr', 'hi', 'hu', 'id', 'it', 'ja', 'jv', 'ko', 'ms', 'nb', 
  'nl', 'pa', 'pl', 'ro', 'sv', 'ta', 'th', 'tr', 'ur', 'vi', 'zh-cn'
];

export const languagesList = [
  { code: 'en', label: 'English' }, { code: 'ru', label: 'Русский' },
  { code: 'pt', label: 'Português' }, { code: 'ar', label: 'العربية' },
  { code: 'bn', label: 'বাংলা' }, { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' }, { code: 'el', label: 'Ελληνικά' },
  { code: 'es', label: 'Español' }, { code: 'fi', label: 'Suomi' },
  { code: 'fr', label: 'Français' }, { code: 'hi', label: 'हिन्दी' },
  { code: 'hu', label: 'Magyar' }, { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'it', label: 'Italiano' }, { code: 'ja', label: '日本語' },
  { code: 'jv', label: 'Basa Jawa' }, { code: 'ko', label: '한국어' },
  { code: 'ms', label: 'Bahasa Melayu' }, { code: 'nb', label: 'Norsk Bokmål' },
  { code: 'nl', label: 'Nederlands' }, { code: 'pa', label: 'ਪੰਜਾਬੀ' },
  { code: 'pl', label: 'Polski' }, { code: 'ro', label: 'Română' },
  { code: 'sv', label: 'Svenska' }, { code: 'ta', label: 'தமிழ்' },
  { code: 'th', label: 'ไทย' }, { code: 'tr', label: 'Türkçe' },
  { code: 'ur', label: 'اردو' }, { code: 'vi', label: 'Tiếng Việt' },
  { code: 'zh-cn', label: '简体中文' },
];

const resources = languageKeys.reduce((acc, lang) => {
  const seo = getSeoTranslations(lang);
  const gen: any = (generatedTranslations as any)[lang] || {};
  
  const rules = {
    translation: {
      // SEO Fallbacks (if not in gen)
      "meta_title_home": gen.meta_title_home || seo.meta_title_home || fallbackTranslations.meta_title_home,
      "meta_desc_home": gen.meta_desc_home || seo.meta_desc_home || fallbackTranslations.meta_desc_home,
      "h1_title": gen.h1_title || seo.h1_title || fallbackTranslations.h1_title,
      "h1_desc": gen.h1_desc || seo.h1_desc || fallbackTranslations.h1_desc,
      "meta_title_terms": gen.meta_title_terms || seo.meta_title_terms || fallbackTranslations.meta_title_terms,
      "meta_desc_terms": gen.meta_desc_terms || seo.meta_desc_terms || fallbackTranslations.meta_desc_terms,
      "meta_title_privacy": gen.meta_title_privacy || seo.meta_title_privacy || fallbackTranslations.meta_title_privacy,
      "meta_desc_privacy": gen.meta_desc_privacy || seo.meta_desc_privacy || fallbackTranslations.meta_desc_privacy,
      "meta_title_mobile": gen.meta_title_mobile || seo.meta_title_mobile || fallbackTranslations.meta_title_mobile,
      "meta_desc_mobile": gen.meta_desc_mobile || seo.meta_desc_mobile || fallbackTranslations.meta_desc_mobile,
      "meta_title_contacts": gen.meta_title_contacts || seo.meta_title_contacts || fallbackTranslations.meta_title_contacts,
      "meta_desc_contacts": gen.meta_desc_contacts || seo.meta_desc_contacts || fallbackTranslations.meta_desc_contacts,
      "meta_title_sitemap": gen.meta_title_sitemap || seo.meta_title_sitemap || fallbackTranslations.meta_title_sitemap,
      "meta_desc_sitemap": gen.meta_desc_sitemap || seo.meta_desc_sitemap || fallbackTranslations.meta_desc_sitemap,
      
      ...gen
    }
  };
  
  acc[lang] = rules;
  if (lang === 'zh-cn') {
     acc['zh-CN'] = rules;
     acc['zh'] = rules;
  }
  return acc;
}, {} as Record<string, any>);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
